import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { ScrollService } from 'shared/domain';
import { RichTextViewComponent } from 'shared/feature-rich-text-view';
import { IconDirective, TooltipDirective, ButtonDirective } from 'shared/ui-common';

import { LinkElementType, GuidelineLinkDto } from '@treetop/shared/model';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tt-anchor-link-item',
  templateUrl: './anchor-link-item.component.html',
  styleUrls: ['./anchor-link-item.component.scss'],
  imports: [IconDirective, MatIconModule, TranslocoPipe, TooltipDirective, RichTextViewComponent, ButtonDirective],
})
export class AnchorLinkItemComponent {
  private scrollService = inject(ScrollService);

  public link = input.required<GuidelineLinkDto>();

  public editLinkClicked = output<GuidelineLinkDto>();
  public removeLinkClicked = output<GuidelineLinkDto>();

  protected scrollToChapter(uniqueChapterId: string) {
    this.scrollService.scrollTo(`${uniqueChapterId}`, true, true);
  }

  protected scrollToComponent(componentUniqueId: string) {
    this.scrollService.scrollTo(componentUniqueId, true, true);
  }

  protected scrollToFlowchart(flowchartElementId: string) {
    this.scrollService.scrollToFlowchartElement(flowchartElementId);
  }

  protected openGuideline(guidelineSlug: string) {
    const host = window.location.origin;
    window.open(`${host}/guideline/preview/${guidelineSlug}`, '_blank');
  }

  protected readonly LinkElementType = LinkElementType;
}
